module.exports = new __parcel__URL__("kitten5.390e7053.png").toString();